<script setup lang="ts">
import { computed, ref } from "vue";
import SvgIcon from "@/common/components/image/svgIcon.vue";
import type { ReportType, ReportBlockType } from "@/common/types/report";

defineProps<{
  block?: ReportBlockType | null;
}>();

const emit = defineEmits(["block:add"]);

const accordions = ref<string[]>(["block", "data", "layout"]);

const menus = computed(() => [
  {
    title: "Básico",
    key: "block",
    items: [
      // title
      {
        key: "block-title",
        label: "Título",
        props: {
          content: { ops: [{ insert: "Edite seu título aqui..." }] },
          id: "block-title",
          style: {
            background: "#dedede",
            color: "#000000",
            "font-family": "Calibri",
            "font-size": "20px",
            "font-style": "normal",
            "font-weight": "bold",
            "line-height": "1.5",
            "margin-top": "10px",
            "margin-bottom": "20px",
            "margin-left": "0px",
            "margin-right": "0px",
            "padding-top": "5px",
            "padding-bottom": "2px",
            "padding-left": "15px",
            "padding-right": "0px",
            "text-align": "left",
            "text-decoration": "none",
          },
          type: "block-title",
        },
      },
      // text
      {
        key: "block-text",
        label: "Texto",
        props: {
          content: { ops: [{ insert: "Edite seu texto aqui..." }] },
          id: "block-text",
          style: {
            color: "#000000",
            "font-size": "15px",
            "font-style": "normal",
            "font-family": "Verdana",
            "font-weight": "normal",
            "line-height": "1.6",
            "text-align": "justify",
          },
          type: "block-text",
        },
      },
      // table
      {
        key: "block-table",
        label: "Tabela",
        props: {
          content: {
            title: "Título da Tabela",
            table: null,
            filters: [],
            columns: [],
            rows: [],
          },
          id: "block-table",
          style: {
            color: "#000000",
            "font-size": "16px",
            "font-style": "normal",
            "font-weight": "normal",
            "font-family": "Verdana",
          },
          type: "block-table",
        },
      },
      // block
      {
        key: "block-data",
        label: "Bloco",
        props: {
          content: {
            title: "Título do Bloco",
            table: null,
            filters: [],
            columns: [],
            fields: [],
            rows: [],
          },
          id: "block-data",
          style: {
            color: "#000000",
            "font-size": "16px",
            "font-style": "normal",
            "font-weight": "normal",
            "font-family": "Verdana",
          },
          type: "block-data",
        },
      },
    ],
  },
  // {
  //   title: "Bloco de Dados",
  //   key: "data",
  //   items: [
  //     { key: "evaluation", label: "Avaliação" },
  //     { key: "analyse", label: "Análise" },
  //     { key: "company", label: "Empresa" },
  //     { key: "employees", label: "Funcionários" },
  //     { key: "forms", label: "Formulários" },
  //     { key: "methods", label: "Métodos" },
  //     { key: "equipments", label: "Equipamentos" },
  //     { key: "samples", label: "Amostras" },
  //     { key: "signatures", label: "Assinaturas" },
  //     { key: "signatures", label: "Assinaturas" },
  //   ],
  // },
]);

function toggleAccordion(section: string) {
  if (accordions.value.includes(section)) {
    accordions.value = accordions.value.filter((s) => s !== section);
  } else {
    accordions.value.push(section);
  }
}

function selectBlock(data: any) {
  emit("block:add", { key: data.key, content: data.props });
}
</script>

<template>
  <div class="menu-editor">
    <template v-for="menu in menus" :key="menu.key">
      <div class="list">
        <div
          class="accordion"
          :class="{
            open: accordions.includes(menu.key),
          }"
          @click="toggleAccordion(menu.key)"
        >
          {{ menu.title }}
          <template v-if="accordions.includes(menu.key)">
            <svg-icon icon="arrow-up" size="1rem" />
          </template>
          <template v-else>
            <svg-icon icon="arrow-down" size="1rem" />
          </template>
        </div>
        <template v-if="accordions.includes(menu.key)">
          <div class="items">
            <template v-for="item in menu.items" :key="item.key">
              <div class="item" @click="selectBlock(item)">
                {{ item.label }}
              </div>
            </template>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.menu-editor {
  display: flex;
  flex-direction: column;

  .list {
    display: flex;
    flex-direction: column;
    height: fit-content;
    border-bottom: 1px solid #ccc;

    .accordion {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding-block: 10px;
      padding-inline: 15px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      user-select: none;

      &.open {
        border-bottom: 1px solid #ccc;
      }
    }

    .items {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
      padding: 15px;
      margin-bottom: 10px;

      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-inline: 10px;
        padding-block: 20px;
        cursor: pointer;
        border-radius: 5px;
        transition: background 200ms ease;
        font-size: 14px;
        background: #fff;
        user-select: none;
        text-align: center;

        &:hover {
          background: var(--primary);
          color: var(--primary-color);
        }
      }
    }
  }
}
</style>
